import Form from './Form';

// TODO: refactor jQuery --> ES
export default class Contact {
	constructor(app) {
		this.app = app;
		const self = this;

		self.bindChatHandler();

		self.submit = $(".js-contact-submit");
		self.sections = '.form-section';
		self.validation = '.formValidation';

		self.currentSectionIdx = 0;
		self.complainttypeonce = true;
		self.produktonce = true;

		// sections
		let start = '.js-contact-start';
		let product = '.js-contact-product';
		let shipping = '.js-contact-shipping';
		let upload = '.js-contact-upload';
		let complaintstart = '.js-contact-complaintstart';
		let complaintdata = '.js-contact-complaintdata';
		let complaintreason = '.js-contact-complaintreason';
		let complaintvendor = '.js-contact-complaintvendor';
		let complainthandling = '.js-contact-complainthandling';
		let spareparts = '.js-contact-spareparts';
		let customer = '.js-contact-customer';

		this.lang = this.app.info.lang
		const frageProduktActiveArray = [
			{"section": start, "hint": ""},
			{"section": upload, "hint": ""},
			{"section": customer, "hint": ""} //"guided":true //Bones nacheinander einblenden
		]
		const frageLieferungActiveArray = [
			{"section": start, "hint": ""},
			{"section": shipping, "hint": ".js-contact-hint-shipping1"},
			{"section": upload, "hint": ""},
			{"section": customer, "hint": ""}
		]
		this.lang == "fr" && frageProduktActiveArray.splice(1, 0, {"section": product, "hint": "" })
		this.lang == "fr" && frageLieferungActiveArray.splice(1, 0, {"section": product, "hint": "" })

		self.ruleset = {
			"frage_produkt": {
				"active": frageProduktActiveArray, // siehe oben// alle nicht angegebenen Sektionen verlieren Ihre is-active Klasse
				// und alle select,textarea und inputs in diesen werden disabled
				"enabled": [],  // list von namen von Feldern, die zusatzlich auf neben der Sektion aktiv sein sollen
				"disabled": [], //siehe oben
				"steps": this.lang == "fr", //validierungsbtn fur einzelene Sektionen
				"send": true //Form am ende senden?
			},
			"frage_konfi": {
				"active": [
					{"section": start, "hint": ""},
					{"section": upload, "hint": ""},
					{"section": customer, "hint": ""}
				],
				"enabled": [], "disabled": [], "steps": false, "send": true
			},
			"frage_shop": {
				"active": [
					{"section": start, "hint": ""},
					{"section": upload, "hint": ""},
					{"section": customer, "hint": ""}
				],
				"enabled": [], "disabled": [], "steps": false, "send": true
			},
			"frage_ersatzteil": {
				"active": [
					{"section": start, "hint": ".js-contact-hint-spareparts"},
					{"section": spareparts, "hint": ".contact-hint-spareparts-product"},
					{"section": upload, "hint": ""},
					{"section": customer, "hint": ""}
				],
				"enabled": [], "disabled": [], "steps": false, "send": true
			},
			"frage_lieferung": {
				"active": frageLieferungActiveArray,
				"enabled": [], "disabled": [], "steps": this.lang == "fr", "send": true
			},
			"frage_service": {
				"active": [
					{"section": start, "hint": ".js-contact-hint-service"},
					{"section": upload, "hint": ""},
					{"section": customer, "hint": ""}
				], "enabled": [], "disabled": [], "steps": false, "send": true
			},
			//"frage_muster":{"active":[{"section":start,"hint":"{{_('js-contact-hint-sample')}}"}],"enabled":[],"disabled":[],"steps":false,"send":false},
			"frage_katalog": {
				"active": [
					{"section": start, "hint": ".js-contact-hint-catalogue"},
					{"section": upload, "hint": ""},
					{"section": customer, "hint": ""}
				], "enabled": [], "disabled": [], "steps": false, "send": true
			},
			"retoure": {
				"active": [
					{"section": start, "hint": ""},
					{"section": complaintdata, "hint": ".js-contact-hint-complaintdata"},
					{"section": upload, "hint": ".file-macro-hint"},
					{"section": customer, "hint": ""}
				],
				"enabled": [], "disabled": [], "steps": true, "send": true
			},
			//"reklamation":{"active":[{"section":start,"hint":"{{_('js-contact-hint-complaint')}}"},{"section":customer,"hint":""}],"enabled":[],"disabled":[],"steps":false,"send":true},
			"reklamation": {
				"active": [
					{"section": start, "hint": ""},
					{"section": complaintstart, "hint": ""},
					{"section": complaintdata, "hint": ".js-contact-hint-complaintdata"},
					{"section": complaintreason, "hint": "", "guided": true},
					{"section": upload, "hint": ".file-macro-hint"},
					{"section": complaintvendor, "hint": ".js-contact-hint-complaintvendor"},
					{"section": complainthandling, "hint": "js-contact-hint-complainthandling", "guided": true},
					{"section": customer, "hint": ""}
				],
				"enabled": [], "disabled": [], "steps": true, "send": true
			},
			"fliesenplan": {
				"active": [
					{"section": start, "hint": ".js-contact-hint-fliesenplan"},
					{"section": upload, "hint": ""},
					{"section": customer, "hint": ""}
				], "enabled": [], "disabled": [], "steps": false, "send": true
			},
			"feedback": {
				"active": [
					{"section": start, "hint": ""},
					{"section": upload, "hint": ""},
					{"section": customer, "hint": ""}
				],
				"enabled": [],
				"disabled": [],
				"steps": false,
				"send": true
			},
			"sonstiges": {
				"active": [
					{"section": start, "hint": ""},
					{"section": upload, "hint": ""},
					{"section": customer, "hint": ""}
				], "enabled": [], "disabled": [], "steps": false, "send": true
			}
		};

		const contactForm = document.querySelector('.js-contact-form');
		if (contactForm !== null) {
			Form.addressAutocomplete({
				address1Field: contactForm.querySelector('#ignt-id-street'),
				address2Field: contactForm.querySelector('#ignt-id-address_add'),
				options: {
					bounds: Form.EUROPE_BOUNDS,
					strictBounds: true,
				},
				zipCodeField: contactForm.querySelector('#ignt-id-zipcode'),
				cityField: contactForm.querySelector('#ignt-id-city'),
				countryField: contactForm.querySelector('#ignt-id-country'),
			});
		}

		// nur weil die richtigen actives noch nicht gesetzt
		$(".js-contact-form").find(self.sections).removeClass("is-active");
		$(".js-contact-form").find(start).addClass("is-active");
		$(".formValidation").hide();

		$("select[name=fragen]").on("change", function (e) {
			$('.js-dsgvo-checkbox').find("input:not(:disabled)").each(function () {
				if (!self.validate($(this))) { // ist valide?
					self.markError($(this).closest(".js-input-group"));
				} else {
					self.unmarkError($(this).closest(".js-input-group"));
					self.showForm(e);
				}
			});
		});


		if ($("select[name=fragen]").val()) {
			$("select[name=fragen]").trigger("change")
		}

		// hide special formgroup
		// only show if bone has the right value
		// no required fields possible!!
		$(".js-complainttype_1").hide();
		$("input[name=complainttype]").on("click", function () {
			if ($(this).val() == "1") {
				$(".js-complainttype_1").show();
				$(".js-complainttype_1").find("input, select").removeAttr("disabled");
			} else {
				$(".js-complainttype_1").hide();
				$(".js-complainttype_1").find("input, select").attr("disabled", "disabled");
			}
		});

		$(".js-complaintvendor_1").hide();
		$("input[name=vendortype]").on("click", function () {
			if ($(this).val() == "1") {
				$(".js-complaintvendor_1").show();
				$(".js-complaintvendor_1").find("input, select").removeAttr("disabled");
			} else {
				$(".js-complaintvendor_1").hide();
				$(".js-complaintvendor_1").find("input, select").attr("disabled", "disabled");
			}
		});

		// hide weiter btn und simuliere klick bei auswahl
		$("input[name=complainttype]").on("click", function () {
			if (self.complainttypeonce) {
				self.complainttypeonce = false;
				$(".js-contact-complaintstart-validate").click().hide();
			}
		});

		$("input[name=produkt]").on("click", function () {
			if (self.produktonce) {
				self.produktonce = false;
				$(".js-contact-product-validate").click().hide();
			}
		})

		$('.js-dsgvo-checkbox').find("input:not(:disabled)").on('change', function () {
			let $frageSelect = $('select[name=fragen]');
			$frageSelect.trigger('change');
		})
	}


	markError(group) {
		group.addClass("is-invalid tip tip-s tip--sticky tip--error");
		group.removeClass("is-valid");
	}


	unmarkError(group) {
		group.removeClass("is-invalid tip--sticky tip--error");
		group.addClass("is-valid");
	}


	handleSection(form, set, idx) {
		let self = this;

		self.currentSectionIdx = idx;
		let val = set["active"][idx];

		form.find(val["section"]).addClass("is-active");

		let fieldsInSection = form.find(val["section"]).find("select,input,textarea")
		fieldsInSection.removeAttr("disabled");

		$(val["section"] + "-msg").removeClass("is-active");

		if (!!val["hint"]) {
			$(val["section"] + "-msg" + val["hint"]).addClass("is-active");
		}

		if (!!set["steps"]) {
			$(val["section"] + "-validate").addClass("is-active"); // zeig weiter btn
			$(val["section"] + "-validate").show();
			$(val["section"] + "-validate").on("click", function (e) {
				e.preventDefault();

				let allvalid = true;

				// validate all not disabled
				form.find("input:not(:disabled),select:not(:disabled),textarea:not(:disabled)").each(function () {
					if (!self.validate($(this))) { // ist valide?
						self.markError($(this).closest(".js-input-group"));
						allvalid = false;
					} else {
						self.unmarkError($(this).closest(".js-input-group"));
					}
				});

				if (allvalid) { // valid
					self.currentSectionIdx += 1;
					self.handleSection(form, set, self.currentSectionIdx);

					if (self.currentSectionIdx == set["active"].length - 1) { // am ende!
						if (!!set["send"]) {
							$(self.submit).removeAttr("disabled");
							$(self.submit).parent().removeClass("tip");
						}
					}
				}
			});
		} else {
			$(val["section"] + "-validate").removeClass("is-active"); // verstecke weiter btn
			$(val["section"] + "-validate").hide();
		}

		if (!!val["guided"]) { // Bones nacheinander einblenden
			let ig = $("input:not(:disabled),select:not(:disabled),textarea:not(:disabled)").closest(".js-input-group");
			let first = true;
			ig.each(function () {
				if ($(this).closest("fieldset.form-section").hasClass(val["section"].substring(1))) { // hasClass benötigt kein ., nur die inputs der aktuellen Section ausblenden
					if (first) {
						first = false;
					} else { // erstes Bone zeigen
						$(this).hide();
					}

					$(this).find("input:not(:disabled),select:not(:disabled),textarea:not(:disabled)").on("change keyup", function () { // wenn gultige eingabe nachstes Bone einblenden
						if ($(this).closest(".js-input-group").hasClass("is-valid")) {
							$(this).closest(".js-input-group").next(".input-group").show();
						}
					})
				}
			})
		}
	}


	// on change show correct Form
	showForm(e) {
		let self = this;

		self.produktonce = true;
		self.complainttypeonce = true;

		let form = $(e.target).closest(".js-contact-form");
		let selected = $(e.target).val();
		let set = self.ruleset[selected];
		self.currentSectionIdx = 0;

		$(self.submit).attr("disabled", "disabled");

		if (!$(self.submit).parent().hasClass("tip")) {
			$(self.submit).parent().addClass("tip")
		}

		// bone validation
		// wird benotigt um valide input-groups zu finden (s
		form.find("input:not(:disabled),select:not(:disabled),textarea:not(:disabled)").on("change keyup", function () {
			if (!self.validate($(this))) { // ist valide?
				self.markError($(this).closest(".js-input-group"));
			} else {
				self.unmarkError($(this).closest(".js-input-group"));
			}
		});

		if (!set) {
			// on page load no option is selected: `set` is undefined
			return;
		}

		if (!set["send"]) { // zerstöre form wenn nicht gesendet werden soll
			form.attr("action", "");
		}

		// alles aus!
		form.find(self.sections).removeClass("is-active");
		form.find(self.sections).find("select,input,textarea").attr("disabled", true);
		form.find(self.validation).removeClass("is-active"); // hide all validation Buttons
		form.find(self.validation).hide();
		form.find(self.validation).off("click"); // alle click handler entfernen!

		// erste Sektionen aktivieren
		if (!!set["steps"]) { // wenn Aktiv zeige validierungbutton in Sektion
			self.handleSection(form, set, 0); // immer an!
			self.handleSection(form, set, 1); // erste echte Sektion
		} else {
			$.each(set["active"], function (idx, val) {
				self.handleSection(form, set, idx)
			});

			if (!!set["send"]) {
				$(self.submit).removeAttr("disabled");
				$(self.submit).parent().removeClass("tip");
			}
		}

		// weitere Felder aktivieren
		$.each(set["enabled"], function (idx, val) {
			$(form.find("*[name=" + val + "]")).removeAttr("disabled");
		});

		// weitere Felder deaktivieren
		$.each(set["disabled"], function (idx, val) {
			$(form.find("*[name=" + val + "]")).attr("disabled", true);
		})
	}


	validate(field) {
		let self = this;

		let fieldValue = field.val();
		let fieldType = field.attr("type");
		let required = field.attr("required");
		let min = field.attr("min");
		let max = field.attr("max");
		let regex = field.attr("pattern");


		// Value standardisieren
		if (fieldType == "radio" || fieldType == "checkbox") {
			let aval = null;
			field.closest(".js-input-group").find("input[name=" + field.attr("name") + "]").each(function () {
				if ($(this).is(":checked")) {
					aval = true;
				}
			});
			fieldValue = aval;
		}

		// required und kein Wert
		if (!!required && !fieldValue) {
			return false;
		}

		// check min max
		if (!!min && !(!!parseInt(fieldValue) && !!parseInt(min) && parseInt(min) <= parseInt(fieldValue)) ||
			!!max && !(!!parseInt(fieldValue) && !!parseInt(max) && parseInt(max) >= parseInt(fieldValue))
		) {
			return false;
		}

		// check pattern
		if (!!required && !!regex) {
			let pattern = new RegExp(regex);
			if (!pattern.test(fieldValue)) {
				return false;
			}
		}
		return true;
	}

	bindChatHandler() {
		document.addEventListener("cookie-allowed-convenience-zammad", evt => $(".js-startChat-popup").removeClass("is-active"))

		$('.js-startChat').on('click', (e) => {
			if (!~app.cookieManager.allowedCookies.indexOf('convenience-zammad')) {
				$(".js-startChat-popup").toggleClass("is-active")
				return;
			}

			if (typeof zammadchat !== 'undefined')
				userlike.userlikeStartChat();
			else
				console.warn('Userlike is not initialized.')
		})
	}
}
